module.exports = __webpack_public_path__ + "static/img/qizhi_active.c924b7bb.png";